import { render, staticRenderFns } from "./BuilderProjectRooms.vue?vue&type=template&id=58a58b88&"
import script from "./BuilderProjectRooms.vue?vue&type=script&lang=js&"
export * from "./BuilderProjectRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports